export type AvailablePageTemplates = {
  documentType: string;
};

export const PageTemplates: AvailablePageTemplates[] = [
  {
    documentType: 'pageHome',
  },
  {
    documentType: 'pageHomePhemex',
  },
  {
    documentType: 'pageHomePionex',
  },
  {
    documentType: 'pagePhemexOffer',
  },
  {
    documentType: 'pageBitunixOffer',
  },
  {
    documentType: 'pageEvent',
  },
  {
    documentType: 'pageMentoring',
  },
  {
    documentType: 'pageLaunch',
  },
  {
    documentType: 'pageThankYou',
  },
  {
    documentType: 'pageAds',
  },
  {
    documentType: 'pageTwitter',
  },
  {
    documentType: 'pageLegal',
  },

  // NEW THEME
  {
    documentType: 'pageHomeNew',
  },
  {
    documentType: 'pageAbout',
  },
  {
    documentType: 'pageCommunity',
  },
  {
    documentType: 'pageKomplettausbildung',
  },
  {
    documentType: 'pageLeaderboards',
  },
  {
    documentType: 'pageManifesto',
  },
  {
    documentType: 'pageLiveCall',
  },
  {
    documentType: 'pageInnerCircle',
  },
  {
    documentType: 'pageLegalNew',
  },
  {
    documentType: 'pageCompetitionBook',
  },
  {
    documentType: 'pageCompetitionBookTy',
  },
  {
    documentType: 'pageShop',
  },
  {
    documentType: 'pageKryptoDay',
  },
  {
    documentType: 'pageMentoringV2',
  },
  {
    documentType: 'pageVslLong',
  },
  {
    documentType: 'pageAdShort',
  },
  {
    documentType: 'pageAdLong',
  },
  {
    documentType: 'pageBastianKeller',
  },
  {
    documentType: 'pageCareer',
  },
  {
    documentType: 'pageConversionLpShort',
  },
  {
    documentType: 'pageLPLong',
  },
  {
    documentType: 'pageTrademania2',
  },
  {
    documentType: 'pageTrademania2ThankYou',
  },
  {
    documentType: 'pageTrademania2Replay',
  },
  {
    documentType: 'pageCustomers',
  },
];
